import { OnHoverTooltip } from '../../common';
import IconSVG from '../../../styles/svg-icons';
import { createAmrPipelineActions } from '../../../actions';
import { PipelineType } from '../../../types/amr-pipeline/enums/PipelineType';
import { useAppDispatch } from '../../../effects/useAppDispatch';
import { useContext } from 'react';
import PipelineContext from '../aggregated/PipelineContext';
import { IssuanceMonitorTab } from '../types/PipelineTabTypes';

interface Props {
    dealLegalName: string;
    dealReferenceName: string;
    disabled?: boolean;
    onClick?: () => void;
}

export function FilterRelatedTransactionsIcon({
    dealLegalName,
    dealReferenceName,
    disabled = false,
    onClick,
}: Props) {
    const dispatch = useAppDispatch();
    const amrPipelineActions = createAmrPipelineActions(PipelineType.Deals);

    const { tab } = useContext(PipelineContext);

    return (
        <OnHoverTooltip overlay={!disabled ? "Related Transactions" : null}>
            <button
                disabled={disabled}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick && onClick();
                    dispatch(
                        tab === IssuanceMonitorTab.Deals
                            ? amrPipelineActions.applyDealSelectFromTable(
                                  dealLegalName,
                                  dealReferenceName
                              )
                            : amrPipelineActions.changeDealSelectFromTable(
                                  dealLegalName,
                                  dealReferenceName
                              )
                    );
                }}
                className="btn-link"
            >
                <IconSVG name="related-transaction" width={16} height={16} />
            </button>
        </OnHoverTooltip>
    );
}
